import { call, takeLatest } from 'typed-redux-saga'
import { ratingApi, RatingNS, ratingSlice } from 'Modules'

function* createRating(action: RatingNS.CreateRating) {
	try {
		const { callback, rating } = action.payload
		yield* call(ratingApi.createRating, rating)
		callback?.()
	} catch (errors) {
		const { errorCallback } = action.payload
		errorCallback?.(errors?.data?.errors?.[0])
	}
}

export function* ratingSaga() {
	yield* takeLatest(ratingSlice.actions.createRating.type, createRating)
}
